"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _default = exports.default = {
  name: 'NotFound',
  data: function data() {
    return {};
  },
  methods: {
    goBack: function goBack() {
      this.$router.replace('/home');
    }
  }
};